import { createFileRoute } from "@tanstack/react-router"

import { SettingsPlaceholder } from "@/features/settings/components/settings-placeholder"

export const Route = createFileRoute("/_authenticated/admin/settings/")({
  component: SystemSettingsPage,
})

function SystemSettingsPage() {
  return <SettingsPlaceholder title="System settings" />
}
